import React from 'react';

type AvatarSize = 'xs' | 'sm' | 'md' | 'lg';

interface AvatarProps {
  initials: string;
  color?: string;
  size?: AvatarSize;
  src?: string;
}

const sizes: Record<AvatarSize, { width: number; fontSize: number; borderRadius: number }> = {
  xs: { width: 22, fontSize: 9, borderRadius: 50 },
  sm: { width: 28, fontSize: 11, borderRadius: 50 },
  md: { width: 36, fontSize: 13, borderRadius: 50 },
  lg: { width: 48, fontSize: 16, borderRadius: 12 },
};

export const Avatar: React.FC<AvatarProps> = ({ initials, color = 'var(--primary)', size = 'md', src }) => {
  const s = sizes[size];
  return (
    <div
      style={{
        width: s.width,
        height: s.width,
        borderRadius: s.borderRadius,
        background: color,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: s.fontSize,
        fontWeight: 700,
        flexShrink: 0,
        overflow: 'hidden',
      }}
    >
      {src ? <img src={src} alt={initials} style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
    </div>
  );
};
